import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Alert, Button, Card, Form } from 'react-bootstrap';
import { useAuth } from '../auth';

const emptyForm = { name: '', email: '', password: '', phone: '', role: 'customer' };

export default function Signup() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  // Set by <AuthToBook> / <ProtectedRoute> (and forwarded from the Login page). A new customer
  // who signed up mid-booking is sent straight back to finish it.
  const from = location.state?.from || null;
  const [form, setForm] = useState(emptyForm);
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (field) => (e) => setForm((prev) => ({ ...prev, [field]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError('');
    try {
      const user = await signup(form);
      // homepage/user_experience.md #6 - a visitor who started a booking then signed up is sent
      // straight back to finish it, whatever role they picked (mirrors Login.js).
      if (from) navigate(from, { replace: true });
      else navigate(user.role === 'owner' ? '/owner' : '/my-bookings');
    } catch (err) {
      setError(err.response?.data?.msg || 'Unable to create account');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card className="mx-auto" style={{ maxWidth: 460 }}>
      <Card.Body>
        <Card.Title as="h3" className="mb-3">
          Create an account
        </Card.Title>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-2">
            <Form.Label>I'm a...</Form.Label>
            <div>
              <Form.Check
                inline
                type="radio"
                label="Customer (renting jewellery)"
                name="role"
                checked={form.role === 'customer'}
                onChange={() => setForm((prev) => ({ ...prev, role: 'customer' }))}
              />
              <Form.Check
                inline
                type="radio"
                label="Jewellery owner"
                name="role"
                checked={form.role === 'owner'}
                onChange={() => setForm((prev) => ({ ...prev, role: 'owner' }))}
              />
            </div>
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Name</Form.Label>
            <Form.Control required value={form.name} onChange={handleChange('name')} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" required value={form.email} onChange={handleChange('email')} />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>Phone</Form.Label>
            <Form.Control value={form.phone} onChange={handleChange('phone')} />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" required minLength={8} value={form.password} onChange={handleChange('password')} />
          </Form.Group>
          <Button type="submit" disabled={submitting} className="w-100">
            {submitting ? 'Creating account…' : 'Create account'}
          </Button>
        </Form>
        <p className="text-center mt-3 mb-0">
          Already have an account? <Link to="/login" state={from ? { from } : undefined}>Log in</Link>
        </p>
      </Card.Body>
    </Card>
  );
}
